<template>
  <div class="pa-4">
    <div class="d-flex align-center mb-4 flex-wrap gap-2">
      <h2 class="text-h5 font-weight-bold mr-4">Pontaj Personal</h2>
      <v-select v-model="luna" :items="luni" item-title="text" item-value="val" label="Luna" variant="outlined" density="compact" style="max-width:160px" @update:model-value="incarca" />
      <v-select v-model="an" :items="ani" label="An" variant="outlined" density="compact" style="max-width:100px" @update:model-value="incarca" />
      <v-spacer />
      <v-chip color="blue-darken-1" variant="tonal">
        Total ore: <strong class="ml-1">{{ totalOre }}</strong>
      </v-chip>
    </div>

    <v-progress-linear v-if="loading" indeterminate color="red-darken-1" class="mb-2" />

    <DxDataGrid
      :data-source="pontaje"
      :show-borders="true"
      :row-alternation-enabled="true"
    >
      <DxColumn data-field="Data" caption="Data" data-type="date" format="dd.MM.yyyy" :width="120" />
      <DxColumn data-field="OraInceput" caption="Intrare" :width="100" />
      <DxColumn data-field="OraFinal" caption="Plecare" :width="100" />
      <DxColumn caption="Ore lucrate" :width="110" cell-template="oreCellTemplate" />

      <template #oreCellTemplate="{ data }">
        {{ calcOre(data.data.OraInceput, data.data.OraFinal) }}
      </template>

      <DxPaging :enabled="false" />
    </DxDataGrid>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { DxDataGrid, DxColumn, DxPaging } from 'devextreme-vue/data-grid'
import PORTAL_Pontaj from '@/services/Portal/PORTAL_Pontaj'

export default defineComponent({
  name: 'Pontaj',
  components: { DxDataGrid, DxColumn, DxPaging },
  data() {
    const now = new Date();
    return {
      loading: false,
      pontaje: [] as any[],
      luna: now.getMonth() + 1,
      an: now.getFullYear(),
      luni: [
        { val: 1, text: 'Ianuarie' }, { val: 2, text: 'Februarie' }, { val: 3, text: 'Martie' },
        { val: 4, text: 'Aprilie' }, { val: 5, text: 'Mai' }, { val: 6, text: 'Iunie' },
        { val: 7, text: 'Iulie' }, { val: 8, text: 'August' }, { val: 9, text: 'Septembrie' },
        { val: 10, text: 'Octombrie' }, { val: 11, text: 'Noiembrie' }, { val: 12, text: 'Decembrie' }
      ],
      ani: [now.getFullYear() - 1, now.getFullYear()]
    }
  },
  computed: {
    totalOre(): string {
      let total = 0;
      for (const p of this.pontaje) {
        const ore = this.calcOreNum(p.OraInceput, p.OraFinal);
        if (ore > 0) total += ore;
      }
      return total.toFixed(1) + ' h';
    }
  },
  mounted() { this.incarca(); },
  methods: {
    async incarca() {
      this.loading = true;
      try {
        const resp = await PORTAL_Pontaj.getPontajLunar(this.an, this.luna);
        this.pontaje = resp.data ?? [];
      } finally {
        this.loading = false;
      }
    },
    calcOreNum(start: string, end: string): number {
      if (!start || !end) return 0;
      try {
        const [sh, sm] = start.split(':').map(Number);
        const [eh, em] = end.split(':').map(Number);
        return Math.max(0, (eh * 60 + em - sh * 60 - sm) / 60);
      } catch { return 0; }
    },
    calcOre(start: string, end: string): string {
      const h = this.calcOreNum(start, end);
      return h > 0 ? h.toFixed(1) + ' h' : '—';
    }
  }
})
</script>
